export const SET_EXAMINATION = 'REPORT_SET_EXAMINATION';

export function setExamination(examination, elementId) {
    return {
        type: SET_EXAMINATION,
        elementId,
        payload: examination,
    };
}
